import React from "react";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Paper,
  Grid,
  Modal,
  TextField
} from "@material-ui/core";
import {
  FavoriteBorder as FavoriteBorderIcon,
  Favorite as FavoriteIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
  Create as CreateIcon,
  Sort as SortIcon,
  MoreHoriz,
  CloseOutlined,
  ArrowDropDown as ArrowDropDownIcon,
  Check as CheckIcon,
  ThumbUp as ThumbUpIcon,
  ChatBubbleOutline,
  Send as SendIcon
} from "@material-ui/icons";
import ReviewsController, { Props } from "./ReviewsController";
import MobileNavEndUser from "../../dashboard/src/MobileNavEndUser.web";
import { Rating } from "@material-ui/lab";
import { logoEverybrand } from "../../dashboard/src/assets";
// import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { userIcon } from "./assets";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      height: 'calc(100vh - 50vh)',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      // paddingBottom: 180,
      // paddingTop: 60
    },
    header: {
      padding: theme.spacing(2),
      // position: "fixed",
      // top: 0,
      // zIndex: 1100,
      backgroundColor: theme.palette.background.paper,
      width: '-webkit-fill-available',
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    reviewCard: {
      // marginBottom: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.divider}`,
      boxShadow: 'none',
      borderRadius: 0
    },
    rating: {
      display: 'flex',
      alignItems: 'center',
      '& .MuiRating-icon': {
        color: '#FFC107',
        fontSize: '16px'
      }
    },
    reviewContent: {
      padding: "12px 16px"
    },
    userInfo: {
      marginLeft: '14px'
    },
    likeButtonView: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
    },
    likeButtonCenter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    userName: {
      fontSize: '13px',
      color: 'rgb(72 115 165)',
      lineHeight: '20px',
      fontWeight: 'bold',
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: '32%'
    },
    reviewText: {
      marginTop: '4px',
      fontSize: '13px',
      color: '#333333',
      lineHeight: '16px'
    },
    likedByCreator: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '12px',
      color: '#9E9E9E',
      margin: '8px 0'
    },
    likeButton: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      color: '#9E9E9E',
      padding: '0px',
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    likeCount: {
      fontSize: '12px',
      opacity: 0.7,
      color: 'rgb(72 115 165)',
    },
    sortSelect: {
      '&:before, &:after': {
        display: 'none'
      },
      '& .MuiSelect-select': {
        padding: '4px 24px 4px 8px',
        fontSize: '14px',
        color: '#1976d2',
        fontWeight: 500
      },
      '& .MuiSelect-icon': {
        color: '#1976d2'
      }
    },
    addReviewSection: {
      backgroundColor: 'rgb(240 240 240)',
      borderRadius: '12px',
      padding: '20px',
      position: 'fixed',
      bottom: '50px',
      left: 0,
      right: 0,
      // zIndex: 1000,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
      width: '-webkit-fill-available',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    addReviewTitle: {
      fontSize: '12px',
      fontWeight: 'bold',
      marginBottom: '4px',
      lineHeight: '0.5',
      color: '#1976d2',
    },
    addReviewSubTitle: {
      fontSize: '12px',
      fontWeight: 500,
      marginBottom: '8px',
      lineHeight: '1.5',
      color: '#1976d2',
    },
    poweredBy: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px 0 0 0',
      '& img': {
        height: '24px',
      }
    }
  });

class Reviews extends ReviewsController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  formatTimeAgo(dateString: string) {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)}d`;
    if (diffInSeconds < 31536000) return `${Math.floor(diffInSeconds / 2592000)}mo`;
    return `${Math.floor(diffInSeconds / 31536000)}y`;
  }

  render() {
    const { classes, navigation } = this.props;
    const { ReviewsList, sortAnchorEl, sortBy, reviewDataShow } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    const isReviewSubmit = urlParams.get('isReviewSubmit');
    console.log("reviewDataShow", reviewDataShow.length);

    return (
      <>
        <Paper className={classes.header} elevation={0}>
          <Grid container alignItems="center">
            <Button
              className={classes.sortButton}
              onClick={this.handleMenuOpen}
              startIcon={<MoreHoriz className={classes.sortIcon} />}
            />
            <Menu
              anchorEl={sortAnchorEl}
              keepMounted
              open={Boolean(sortAnchorEl)}
              onClose={() => this.handleMenuClose()}
            >
              <MenuItem
                selected={sortBy === "newest"}
                onClick={() => this.handleMenuClose("newest")}
              >
                Newest First
              </MenuItem>
              <MenuItem
                selected={sortBy === "highest"}
                onClick={() => this.handleMenuClose("highest")}
              >
                Highest Rated
              </MenuItem>
            </Menu>
            <Typography variant="subtitle2" style={{ fontWeight: "bold", marginLeft: '51px' }}>
              {reviewDataShow?.length > 0 && `${reviewDataShow.length} `}Reviews
            </Typography>
            {/* <Button
              className={classes.sortButton}
              onClick={this.handleClose}
              startIcon={<CloseOutlined className={classes.sortIcon} />}
              style={{ justifyContent: "flex-end" }}
            /> */}
            <Box />
          </Grid>
        </Paper>
        {/* Reviews List */}
        <Box className={classes.root}>
          {Array.isArray(reviewDataShow) && reviewDataShow.length > 0 ? (
            reviewDataShow.map((review: any) => (
              <Card key={review.id} className={classes.reviewCard} elevation={0}>
                <CardContent className={classes.reviewContent}>
                  <Box display="flex" alignItems="flex-start">

                    {/* Avatar */}
                    <Avatar
                      src={review.userAvatar || undefined}
                      className={classes.avatar}
                    >
                      {!review.userAvatar
                        ? review.userName?.charAt(0)?.toUpperCase()
                        : null}
                    </Avatar>

                    <Box style={{ marginLeft: 10, flex: 1, minWidth: 0 }}>

                      {/* HEADER */}
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >

                        {/* LEFT */}
                        <Box
                          display="flex"
                          alignItems="center"
                          style={{ flex: 1, minWidth: 0 }}
                        >
                          <Typography
                            className={classes.userName}
                            style={{
                              maxWidth: 120,
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              marginRight: 6
                            }}
                          >
                            {review.userName}
                          </Typography>

                          <Typography
                            variant="caption"
                            style={{ marginRight: 6, color: "#777", fontSize: '0.65rem' }}
                          >
                            {this.formatTimeAgo(review.date)}
                          </Typography>

                          <Rating
                            value={review.rating}
                            readOnly
                            size="small"
                            icon={<StarIcon style={{ color: "#FFC629" }} fontSize="inherit" />}
                            emptyIcon={<StarBorderIcon style={{ color: "#000" }} fontSize="inherit" />}
                          />
                        </Box>

                        {/* LIKE */}
                        <Box display="flex" alignItems="center">
                          <IconButton
                            size="small"
                            onClick={() => this.toggleLike(review.id)}
                            style={{ padding: 4 }}
                          >
                            {review.isLiked ? (
                              <FavoriteIcon style={{ color: "#ff4d4f", fontSize: 18 }} />
                            ) : (
                              <FavoriteBorderIcon style={{ fontSize: 18 }} />
                            )}
                          </IconButton>

                          <Typography variant="caption">
                            {review.like_count ?? 0}
                          </Typography>
                        </Box>

                      </Box>

                      {/* REVIEW TEXT */}
                      <Typography className={classes.reviewText}>
                        {review.comment}
                      </Typography>

                      {/* COMMENT ROW */}
                      <Box
                        display="flex"
                        alignItems="center"
                        style={{ marginTop: 4, cursor: "pointer" }}
                        onClick={() => this.handleReviewComment(review.id)}
                      >
                        <ChatBubbleOutline style={{ fontSize: 18 }} />
                        <Typography
                          variant="caption"
                          style={{ marginLeft: 4 }}
                        >
                          {this.state.reviewComments[review.id]?.length || 0} comments
                        </Typography>
                      </Box>

                      {/* COMMENTS SECTION */}
                      {this.state.openReviewComments === review.id && (
                        <Box style={{ marginTop: 8, paddingLeft: 10 }}>

                          {(this.state.reviewComments[review.id] || []).map((c: any) => (
                            <Box key={c.id} style={{ marginBottom: 8 }}>
                              <Typography
                                variant="caption"
                                style={{ fontWeight: 600 }}
                              >
                                {c.userName}
                              </Typography>
                              <Typography variant="body2">
                                {c.text}
                              </Typography>
                            </Box>
                          ))}

                          {/* ADD COMMENT */}
                          <Box style={{ display: "flex", alignItems: "center", marginTop: 6 }}>
                            <input
                              style={{
                                flex: 1,
                                border: "1px solid #ddd",
                                borderRadius: 20,
                                padding: "6px 12px",
                                fontSize: 13
                              }}
                              placeholder="Add a comment..."
                              value={this.getCommentDraft(review.id)}
                              onChange={(e) =>
                                this.setCommentDraft(review.id, e.target.value)
                              }
                            />

                            <IconButton
                              size="small"
                              onClick={() => this.handleAddReviewComment(review.id)}
                            >
                              <SendIcon fontSize="small" />
                            </IconButton>
                          </Box>

                        </Box>
                      )}

                    </Box>
                  </Box>
                </CardContent>
              </Card>
            ))
          ) : (

            // ✅ EMPTY STATE
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              style={{ padding: "40px 0" }}
            >
              <Typography variant="h6" style={{ color: "#555", marginBottom: 6 }}>
                No reviews yet
              </Typography>

              <Typography variant="body2" style={{ color: "#999" }}>
                Be the first to share your experience!
              </Typography>
            </Box>

          )}
        </Box>
        {!isReviewSubmit && (<Box className={classes.addReviewSection}>
          <Typography className={classes.addReviewTitle}>Leave a Review</Typography>
          <Typography className={classes.addReviewSubTitle}>Share your experience</Typography>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Rating
              value={this.state.rating || 0}
              precision={1}
              icon={<StarIcon style={{ color: '#FFC629', fontSize: '34px' }} />}
              emptyIcon={<StarBorderIcon style={{ color: '#000', fontSize: '34px' }} />}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  this.setState({ rating: newValue }, () => {
                    this.handleRedirect("AddReview");
                  });
                }
              }}
            />
          </Box>
          {/* Powered by */}
          <Box className={classes.poweredBy}>
            <Typography variant="caption" style={{ color: '#1976d2', fontSize: '12px', opacity: 0.7 }}>
              Powered by
            </Typography>
            <img
              src={logoEverybrand}
              alt="Everybrand"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </Box>
        </Box>)}

        {/* Mobile Navigation */}
        <MobileNavEndUser navigation={navigation} />
        <Modal
          open={this.state.commentAuthOpen}
          onClose={this.closeCommentAuth}
        >
          <Box
            style={{
              position: "fixed",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              width: "min(92vw, 420px)",
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              boxSizing: "border-box",
              outline: "none",
            }}
          >
            <Typography style={{ fontWeight: 700, marginBottom: 12 }}>
              {this.state.commentAuthStep === 0
                ? "Add your name"
                : this.state.commentAuthStep === 1
                  ? "Verify your phone"
                  : "Enter OTP"}
            </Typography>

            {this.state.commentAuthStep === 0 && (
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Full name"
                value={this.state.userName}
                onChange={(e) => this.setState({ userName: e.target.value })}
              />
            )}

            {this.state.commentAuthStep === 1 && (
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Phone number"
                value={this.state.phoneNumber}
                onChange={(e) => this.setState({ phoneNumber: e.target.value })}
              />
            )}

            {this.state.commentAuthStep === 2 && (
              <TextField
                fullWidth
                variant="outlined"
                placeholder="6-digit OTP"
                value={this.state.otpCode.join("")}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                  const otpArr = Array(6).fill("");
                  value.split("").forEach((digit, idx) => {
                    otpArr[idx] = digit;
                  });
                  this.setState({ otpCode: otpArr });
                }}
              />
            )}

            <Box style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 14 }}>
              <Button onClick={this.closeCommentAuth}>Cancel</Button>
              <Button
                variant="contained"
                style={{ backgroundColor: "#FFC629", color: "#000" }}
                onClick={this.handleCommentAuthContinue}
              >
                {this.state.commentAuthStep === 2 ? "Verify & post" : "Continue"}
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
      //Merge Engine End DefaultContainer
    );
  }
}

// Customizable Area Start
export default withStyles(styles)(Reviews);
// Customizable Area End
